export const GanttCouriersSettingsModeType = {
    PLANNED: 'planned',
    CURRENT: 'current',
    APPROACHED: 'approached',
};
export type GanttCouriersSettingsModeType =
    (typeof GanttCouriersSettingsModeType)[keyof typeof GanttCouriersSettingsModeType];

export class GanttCouriersSettings {
    public visibleId: boolean = true;
    public visibleTime: boolean = true;
    public visibleParcels: boolean = true;
    public visibleStops: boolean = true;
    public visibleDistance: boolean = true;
    public visibleCost: boolean = false;
    public visiblePercents: boolean = true;
    public visibleTimeLine: boolean = true;
    public pixelsPerMinute: number = 1;
    public useRealTime: boolean = true;
    public counter: number = 0;
    public assignmentIds: number[] = [];
    public assignmentIdsLoaded: boolean = false;
    public dataMode: GanttCouriersSettingsModeType = GanttCouriersSettingsModeType.PLANNED;
    public useDebugData: boolean = false;
    public eachStopTimeMinutes: number = 5;
    public eachDeliveryTimeMinutes: number = 1;
    public visibleDay: boolean = true;
    private readonly _minimumPixelsPerMinute: number = 1;
    public useDumpApi: boolean = false;
    private selectedDay: string | null = null;

    public setSelectedDay(selectedDay: string): this {
        this.selectedDay = selectedDay;
        return this;
    }

    public getSelectedDay(): string {
        if (this.selectedDay === null) {
            throw new Error('Selected day is not set');
        }
        return this.selectedDay;
    }

    public isSetSelectedDay(): boolean {
        return this.selectedDay !== null;
    }

    public setUseDumpApi(useDumpApi: boolean): this {
        this.useDumpApi = useDumpApi;
        return this;
    }

    public setRouteStopTimes(eachStopTimeMinutes: number, eachDeliveryTimeMinutes: number): this {
        this.eachStopTimeMinutes = eachStopTimeMinutes;
        this.eachDeliveryTimeMinutes = eachDeliveryTimeMinutes;
        return this;
    }

    public setMode(dateMode: GanttCouriersSettingsModeType): this {
        this.dataMode = dateMode;
        return this;
    }

    public setAssignmentIds(assignmentIds: number[]): this {
        this.assignmentIds = assignmentIds;
        this.assignmentIdsLoaded = false;
        return this;
    }

    public setSimpleView(simpleView: boolean = true): this {
        this.visibleDay = !simpleView;
        this.visibleId = !simpleView;
        this.visibleTime = !simpleView;
        this.visibleParcels = !simpleView;
        this.visibleStops = !simpleView;
        this.visibleDistance = !simpleView;
        this.visibleCost = !simpleView;
        return this;
    }

    public setDataView() {
        this.visibleDay = true;
        this.visibleId = true;
        this.visibleTime = true;
        this.visibleParcels = true;
        this.visibleStops = true;
        this.visibleDistance = true;
        this.visibleCost = true;
        this.visiblePercents = true;
        this.visibleTimeLine = false;
        return this;
    }

    public setTimelineView() {
        this.visibleDay = true;
        this.visibleId = true;
        this.visibleTime = false;
        this.visibleParcels = false;
        this.visibleStops = false;
        this.visibleDistance = false;
        this.visibleCost = false;
        this.visiblePercents = false;
        this.visibleTimeLine = true;
        return this;
    }

    public tickCounter(withReload: boolean = true): this {
        this.counter++;
        if (withReload) {
            this.assignmentIdsLoaded = false;
        }
        return this;
    }

    public setUseRealTime(useRealTime: boolean): this {
        this.useRealTime = useRealTime;
        return this;
    }

    public toggleSimpleView(): this {
        this.visibleId = !this.visibleId;
        this.visibleTime = !this.visibleTime;
        this.visibleParcels = !this.visibleParcels;
        this.visibleStops = !this.visibleStops;
        this.visibleDistance = !this.visibleDistance;
        this.visibleCost = !this.visibleCost;
        return this;
    }

    public setPixelsPerMinute(
        pixelsPerMinute: number,
        useMinimumValueIfNeeded: boolean = false
    ): this {
        this.pixelsPerMinute = pixelsPerMinute;
        if (useMinimumValueIfNeeded && this.pixelsPerMinute < this._minimumPixelsPerMinute) {
            this.pixelsPerMinute = this._minimumPixelsPerMinute;
        }
        return this;
    }
}
